import React from "react";
import { Box, Dialog, Typography, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import WysiwygViewer from "components/TextEditorViewer";

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 200,
    padding: 30,
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    fontSize: 14,
  },
  title: {
    fontWeight: "700",
    color: "#000",
    fontSize: 18,
  },
  buttonBox: {
    marginTop: 53,
    marginLeft: "auto",
  },
  saveButton: {
    backgroundColor: "#6B6F7E",
    color: "#FFF",
    "&:hover": {
      backgroundColor: "rgb(101 101 101 / 36%)",
    },
  },
  link: {
    borderBottom: "1px solid #dfdfdf",
    padding: 10,
    color: "#044ba1",
    cursor: "pointer",
    marginTop: 10,
  },
}));

const PageCompose = ({ open, handleClose, time = [] }) => {
  const classes = useStyles();

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.root }}>
      <Typography className={classes.title}>Цагийн хуваарь</Typography>
      <Box className="mt-[10px] mb-[20px]">
        <Typography className="text-[gray]"></Typography>

        {/* Mapping over inst array */}
        {time?.map((item, index) => (
          <Box
            key={index}
            className={classes.link}
            // onClick={() => window.open(item.content, "_blank")}
          >
            <WysiwygViewer data={item.content} />
          </Box>
        ))}
      </Box>
      <Box className={classes.buttonBox}>
        <Button className={classes.saveButton} onClick={handleClose}>
          Цонхыг хаах
        </Button>
      </Box>
    </Dialog>
  );
};

export default PageCompose;
